import * as types from '../mutation-types'
import auth0 from 'auth0-js'
import * as msal from '@azure/msal-browser'

export function authStore(Vue, authZero, ms, callbackRouting) {
  const webAuth = new auth0.WebAuth(authZero)

  if (!ms.auth) ms.auth = {}

  ms.auth.redirectUri = origin + '/callbackms' // override this
  ms.auth.navigateToLoginRequestUrl = false // override this

  var msAuth = new msal.PublicClientApplication(ms)

  if (window.location.href.toLowerCase().indexOf('callbackms') > -1) {
    saveState('auth.mserror', '')

    // Register Callbacks for Redirect flow
    msAuth
      .handleRedirectPromise()
      .then((response) => {
        if (response !== null) {
          var profile = {}

          if (
            response.idTokenClaims &&
            response.idTokenClaims.name &&
            response.idTokenClaims.name !== ''
          ) {
            profile.firstName = response.idTokenClaims.name
              .split(' ')
              .slice(0, -1)
              .join(' ')
            profile.lastName = response.idTokenClaims.name
              .split(' ')
              .slice(-1)
              .join(' ')
          }

          var _auth = {
            idToken: response.idToken,
            accessToken: response.accessToken,
            expiresAt: response.expiresOn,
            profile: profile,
            method: 'Microsoft',
          }

          saveState('auth.identity', _auth)
          saveState('auth.mserror', 'success')

          console.log('MS login complete... waiting on callbackms...')
        } else {
          console.log('Bypassing MS redirect')
        }
      })
      .catch((error) => {
        console.log(error)
        saveState('auth.mserror', error)
      })
  }

  // if (window.location.href.toLowerCase().indexOf('callbackms') > -1) {
  //   msAuth = new msal.PublicClientApplication(ms)
  //   msAuth.handleRedirectCallback(handleAuthenticationMs)
  // }
  /*
    function handleAuthenticationMs(error, response) {
      if (error) {
        // we only care about this if it's a callbackms
        console.log('ms fired error...')
        saveState('auth.mserror', error)
      } else {
        console.log('ms fired success..')
        saveState('auth.mserror', '')
        console.log(response)

        var profile = {}

        if (
          response.account &&
          response.account.name &&
          response.account.name !== ''
        ) {
          profile.firstName = response.account.name
            .split(' ')
            .slice(0, -1)
            .join(' ')
          profile.lastName = response.account.name
            .split(' ')
            .slice(-1)
            .join(' ')
        }

        let _auth = {
          idToken: response.idToken.rawIdToken,
          accessToken: response.accessToken,
          expiresAt: JSON.stringify(
            response.idToken.expiration * 1000 + new Date().getTime()
          ),
          profile: profile,
          refreshToken: response.refreshToken,
          method: 'Microsoft',
        }

        if (!_auth.accessToken) {
          var msAuth = new msal.PublicClientApplication(ms)

          var tokenRequest = {
            scopes: ['api://chirhos/User', 'user.read', 'directory.read.all']
          }
          msAuth.acquireTokenSilent(tokenRequest)
            .then(response => {
              _auth.accesToken = response.accessToken
              saveState('auth.identity', _auth)
              console.log('ms done with retrieved access token... allowing continue to callback...')
            })
            .catch(err => {
              console.log('Could not get access token (was missing, still missing)')
            });
        } else {
          saveState('auth.identity', _auth)
          console.log('ms done with existing access token... allowing continue to callback...')
        }
      }
    }
  */
  const state = {
    identity: getSavedState('auth.identity'),
  }

  const mutations = {
    [types.SET_AUTH](state, newValue) {
      state.identity = newValue
      saveState('auth.identity', newValue)
    },
  }

  const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
      if (!state.identity) return false
      if (!state.identity.idToken) return false
      // if (state.identity.profile.entityId === '') return false
      return new Date() < new Date(state.identity.expiresAt)
    },
  }

  const actions = {
    // Logs in the current user.
    logIn() {
      webAuth.authorize()
    },

    logInMs() {
      msAuth.loginRedirect({
        scopes: ['api://chirhos/User', 'user.read'],
      })

      // if (!msAuth) msAuth = new msal.PublicClientApplication(ms)
      // msAuth.handleRedirectCallback(handleAuthenticationMs)
      // msAuth.loginRedirect({
      //   scopes: ['api://chirhos/User', 'user.read', 'directory.read.all'],
      // })
    },

    handleAuthentication({ commit }) {
      console.log('handling auth0...')
      return new Promise((resolve, reject) => {
        webAuth.parseHash((err, authResult) => {
          if (authResult && authResult.accessToken && authResult.idToken) {
            console.log('Auth0 success')
            console.log(authResult)
            var _auth = {
              idToken: authResult.idToken,
              accessToken: authResult.accessToken,
              expiresAt: authResult.expiresIn * 1000 + new Date().getTime(),
              profile: authResult.idTokenPayload,
              refreshToken: authResult.refreshToken,
              method: 'Auth0',
            }

            commit(types.SET_AUTH, _auth)

            resolve(_auth)
          } else if (err) {
            commit(types.SET_AUTH, null)
            console.log(err)
            //router.push('/')
            reject(err)
          }
        })
      })
    },

    // Logs out the current user.
    logOut({ commit }) {
      return new Promise((/* resolve, reject */) => {
        if (state.identity && state.identity.method) {
          switch (state.identity.method) {
            case 'Auth0':
              commit(types.SET_AUTH, null)
              localStorage.removeItem('auth.identity')
              webAuth.logout({
                returnTo: origin, // go back to root or default
                client_id: authZero.clientID,
              })
              break
            case 'Microsoft':
              commit(types.SET_AUTH, null)
              localStorage.removeItem('auth.identity')
              msAuth.logout()
              break
          }
        }
      })
      // })
    },

    // Validates the current user's token and refreshes it
    // with new data from the API.
    validate({ state }) {
      if (
        !state.identity // ||
        // !state.user.profile ||
        // !state.user.profile.entityId
      ) {
        return Promise.resolve(null)
      }

      // Check with Dan if we need to verify at this point? -> /api/Security/VerifyJsonWebSignature
      return state.identity
    },
  }

  return {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
  }
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

// function setDefaultAuthHeaders(state) {
//   // console.log(state.identity)
//   // axios.defaults.headers.common.Authorization = state.identity
//   //   ? 'Bearer ' + state.identity.accessToken
//   //   : ''
//   if (state.identity && state.identity.accessToken) {
//     _chirhos = new ChiRhos({
//       basePath: '',
//       accessToken: state.identity.accessToken,
//     })
//   }
// }
